import { render, staticRenderFns } from "./ShopHeaderCard.vue?vue&type=template&id=536bf1a1"
import script from "./ShopHeaderCard.vue?vue&type=script&lang=js"
export * from "./ShopHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports